import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectHomeData, selectSpeedFormationSave, selectSpeedFormationDate } from '@/containers/HomePage/HomeSelectors'
import { setIsEditingSpeedFormation, setSpeedFormationDate } from '@/containers/HomePage/HomeSlice'
import { homeActions } from '@/containers/HomePage/HomeSagas'

const useFormationForm = () => {
  const dispatch = useDispatch()
  const { speedFormation } = useSelector(selectHomeData)
  const { tinymceKey } = useSelector(selectAuthData)
  const { isLoading, error, errorMessage } = useSelector(selectSpeedFormationSave)
  const date = useSelector(selectSpeedFormationDate)
  const editorRef = useRef(null)

  const setIsEditing = value => dispatch(setIsEditingSpeedFormation(value))
  const setDate = value => dispatch(setSpeedFormationDate(value))

  const saveSpeedFormation = () => {
    if (!editorRef.current) {
      return
    }
    const text = editorRef.current.getContent()
    const formattedDate = new Date(date).toISOString().slice(0, 10)
    dispatch({ type: homeActions.SAVE_SPEED_FORMATION, text, date: formattedDate })
  }

  return {
    speedFormation,
    editorRef,
    date,
    setDate,
    setIsEditing,
    saveSpeedFormation,
    isLoading,
    error,
    errorMessage,
    tinymceKey,
  }
}

export default useFormationForm
